var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransparencyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6666 44.6399V12.4532C58.6666 9.25319 56.0532 6.87985 52.8799 7.14652H52.7199C47.1199 7.62652 38.6132 10.4799 33.8666 13.4665L33.4132 13.7599C32.6399 14.2399 31.3599 14.2399 30.5866 13.7599L29.9199 13.3599C25.1733 10.3999 16.6933 7.57319 11.0933 7.11985C7.91992 6.85319 5.33325 9.25319 5.33325 12.4265V44.6399C5.33325 47.1999 7.41325 49.5999 9.97325 49.9199L10.7466 50.0265C16.5333 50.7999 25.4666 53.7332 30.5866 56.5332L30.6933 56.5865C31.4133 56.9865 32.5599 56.9865 33.2533 56.5865C38.3733 53.7599 47.3333 50.7999 53.1466 50.0265L54.0266 49.9199C56.5866 49.5999 58.6666 47.1999 58.6666 44.6399Z",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14.64V54.64",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 22.64H14.6667",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 30.64H14.6667",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparencyIcon);
export default __webpack_public_path__ + "static/media/transparency-icon.42e7542f497471fdd41b45291a9d77f3.svg";
export { ForwardRef as ReactComponent };